// hooks/useIframeResizer.js
import { useEffect, useRef } from 'react';

export const useIframeResizer = (options = {}) => {
    const {
        defaultHeight = 500,
        minHeight = 150,
        maxHeight = 2500
    } = options;

    const iframeRef = useRef(null);
    const currentHeight = useRef(defaultHeight);

    useEffect(() => {
        const handleMessage = (event) => {
            // Vérifier que le message vient de l'iframe
            if (!iframeRef.current || event.source !== iframeRef.current.contentWindow) {
                return;
            }

            // Vérifier le type de message
            if (event.data?.type === 'resize') {
                const newHeight = Math.max(
                    minHeight,
                    Math.min(Math.ceil(event.data.height + 10), maxHeight)
                );

                // Éviter les mises à jour inutiles
                if (newHeight !== currentHeight.current) {
                    currentHeight.current = newHeight;
                    iframeRef.current.style.height = `${newHeight}px`;
                }
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [minHeight, maxHeight]);

    return iframeRef;
};